"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateHeaderParams = exports.addExtraHeadersByFamilyApi = exports.getAuthHeadersToken = void 0;
const next13_enums_environment_1 = require("@gerenciatd/next13.enums.environment");
const calculateEnvName = (build, context) => {
    // si estoy en build calculo mi environment por la constante de env
    let envName = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
    if (!build && context && context.environment && context.environment.name) {
        // si estoy en cliente lo miro de context
        envName = context.environment.name;
    }
    return envName;
};
const calculateProperTimeOut = (build, familyApi, envName) => {
    let timeout = 5000;
    if (envName === next13_enums_environment_1.ENV_NAME.QA) {
        timeout = 1500000;
    }
    if (envName === next13_enums_environment_1.ENV_NAME.DEV && !build) {
        // me interesa que qa responda y puede tardar mucho
        timeout = 1500000;
    }
    if (envName === next13_enums_environment_1.ENV_NAME.DEV && build && familyApi !== next13_enums_environment_1.FAMILY_API.BUCKET) {
        // me interesa estudiar cliente y qa fallará e ira al mock
        timeout = 10000;
    }
    if (envName === next13_enums_environment_1.ENV_NAME.QA) {
        // tanto en el pipeline como en cliente me interesa esperar
        timeout = 1500000;
    }
    if (envName === next13_enums_environment_1.ENV_NAME.PROD) {
        // tiempo razonable
        timeout = 15000;
    }
    return timeout;
};
const getAuthHeadersToken = (build, familyApi = next13_enums_environment_1.FAMILY_API.ORION) => {
    let authorizationHeader = {};
    try {
        const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
        if (familyApi === next13_enums_environment_1.FAMILY_API.ORION) {
            if (currentEnv === next13_enums_environment_1.ENV_NAME.QA && build) {
                authorizationHeader = JSON.parse(`${process.env.NEXT_PUBLIC_ORION_IAP_TOKEN}`);
            }
        }
        if (familyApi === next13_enums_environment_1.FAMILY_API.CATALOGUE) {
            if (currentEnv === next13_enums_environment_1.ENV_NAME.QA && build) {
                authorizationHeader = JSON.parse(`${process.env.NEXT_PUBLIC_CATALOGUE_IAP_TOKEN}`);
            }
        }
        if (familyApi === next13_enums_environment_1.FAMILY_API.BUCKET) {
            if (currentEnv === next13_enums_environment_1.ENV_NAME.QA && build) {
                authorizationHeader = JSON.parse(`${process.env.NEXT_PUBLIC_CMS_TOKEN}`);
            }
        }
        if (familyApi === next13_enums_environment_1.FAMILY_API.CUSTO) {
            if (currentEnv === next13_enums_environment_1.ENV_NAME.QA && build) {
                authorizationHeader = JSON.parse(`${process.env.NEXT_PUBLIC_CUSTOMIZER_TOKEN}`);
            }
        }
        if (familyApi === next13_enums_environment_1.FAMILY_API.CUSTO_STANDARD) {
            if (currentEnv === next13_enums_environment_1.ENV_NAME.QA && build) {
                authorizationHeader = JSON.parse(`${process.env.NEXT_PUBLIC_CUSTOMIZER_STANDARD_TOKEN}`);
            }
        }
        return authorizationHeader;
    }
    catch (err) {
        // No estamos en build
        return authorizationHeader;
    }
};
exports.getAuthHeadersToken = getAuthHeadersToken;
const extractOriginHeader = (context, familyApi, envName, build) => {
    let originHeader = {};
    if (build) {
        if (familyApi === next13_enums_environment_1.FAMILY_API.ORION && (envName === next13_enums_environment_1.ENV_NAME.DEV || envName === next13_enums_environment_1.ENV_NAME.PROD)) {
            originHeader = {
                Origin: 'https://www.movistar.es',
            };
        }
        if ((familyApi === next13_enums_environment_1.FAMILY_API.CATALOGUE || familyApi === next13_enums_environment_1.FAMILY_API.CUSTO)
            && envName === next13_enums_environment_1.ENV_NAME.QA) {
            originHeader = {
                Origin: 'https://qa.cms.col.movistar.es',
            };
        }
        if ((familyApi === next13_enums_environment_1.FAMILY_API.CATALOGUE || familyApi === next13_enums_environment_1.FAMILY_API.CUSTO)
            && (envName === next13_enums_environment_1.ENV_NAME.PROD || envName === next13_enums_environment_1.ENV_NAME.DEV)) {
            originHeader = {
                Origin: 'https://www.movistar.es',
            };
        }
        if ((familyApi === next13_enums_environment_1.FAMILY_API.GEO)
            && (envName === next13_enums_environment_1.ENV_NAME.PROD || envName === next13_enums_environment_1.ENV_NAME.QA)) {
            originHeader = {
                Origin: 'https://www.movistar.es',
            };
        }
        if (familyApi === next13_enums_environment_1.FAMILY_API.TELCO && envName === next13_enums_environment_1.ENV_NAME.QA) {
            originHeader = {
                Origin: 'https://col10mgmt.tsm.inet',
            };
        }
        if (familyApi === next13_enums_environment_1.FAMILY_API.TELCO && envName === next13_enums_environment_1.ENV_NAME.PROD) {
            originHeader = {
                Origin: 'https://www.movistar.es',
            };
        }
        if (originHeader &&
            !originHeader.Origin &&
            context &&
            context.environment &&
            context.environment[familyApi] &&
            context.environment[familyApi].endpoint) {
            originHeader = {
                Origin: context.environment[familyApi].endpoint,
            };
        }
    }
    return originHeader;
};
const extractHeadersFromClient = (context, familyApi) => {
    let headerRes = {};
    if (context && context.environment && context.environment[familyApi]) {
        headerRes = context.environment && context.environment[familyApi].headers;
    }
    return headerRes;
};
const addExtraHeadersByFamilyApi = (build, familyApi) => {
    let res = {};
    if (build && (familyApi === next13_enums_environment_1.FAMILY_API.CUSTO || familyApi === next13_enums_environment_1.FAMILY_API.ORION || familyApi === next13_enums_environment_1.FAMILY_API.CATALOGUE)) {
        res = { 'Skip-Cache': true, 'User-Agent': `${process.env.NEXT_PUBLIC_PROJECT_ID}` };
    }
    return res;
};
exports.addExtraHeadersByFamilyApi = addExtraHeadersByFamilyApi;
const calculateHeaderParams = (build, familyApi, context) => {
    let headers = {};
    const envName = calculateEnvName(build, context);
    const headersOnBuild = (0, exports.getAuthHeadersToken)(build, familyApi);
    const headersOnClient = extractHeadersFromClient(context, familyApi);
    const originHeader = extractOriginHeader(context, familyApi, envName, build);
    const extraHeaders = (0, exports.addExtraHeadersByFamilyApi)(build, familyApi);
    const timeout = calculateProperTimeOut(build, familyApi, envName);
    // build Headers
    headers = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, headersOnClient), originHeader), headersOnBuild), extraHeaders), { timeout });
    // Añadimos la cabecera origin si es necesaria
    if (build) {
        delete headers.withCredentials;
        if (familyApi === next13_enums_environment_1.FAMILY_API.CATALOGUE) {
            delete headers['content-type'];
        }
    }
    return headers;
};
exports.calculateHeaderParams = calculateHeaderParams;
exports.default = exports.calculateHeaderParams;
//# sourceMappingURL=index.js.map